<template>
    <div>
      <div class="profile-header">
        <div class="relative">
          <div class="cover-container rounded-t-lg bg-white rounded-sm p-4 text-center" style="
              -webkit-box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
               box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);">
            <img :src="items.image" alt="user-profile-cover" class="rounded-sm" style="max-height: 400px;">
          </div>
        </div>
      </div>

        <div class="vx-col w-full sm:w-1/1 mb-base">
            <vx-card>
                <p class="text-grey" v-html="items.description"></p>
            </vx-card>
        </div>


        <br>
        <div id="ecommerce-wishlist-demo">
            <div class="items-grid-view vx-row match-height" v-if="items.prizes.length" appear>
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full" v-for="(item,index) in items.prizes" :key="item.objectID">
                    <item-grid-view :item="item" :eventId="items.id">
                        <!-- SLOT: ACTION BUTTONS -->
                        <template slot="action-buttons">
                            <div class="flex flex-wrap">
                                <!-- SECONDARY BUTTON: MOVE TO CART -->
                                <div
                                    class="item-view-secondary-action-btn bg-primary p-3 flex flex-grow items-center justify-center text-white cursor-pointer">
                                    <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                                    <span class="text-sm font-semibold ml-2" >{{ $t('more') }}</span>
                                </div>
                            </div>
                        </template>
                    </item-grid-view>
                </div>
            </div>
        </div>

    </div>



</template>

<script>
    import ItemGridView from './EventsPrizesList.vue';

    export default {
        components: {
            ItemGridView
        },
        data() {
            return {
                items: []
            }
        },
        created() {
            const thisIns = this;

            // eslint-disable-next-line no-undef
            axios.get(apiUrl+'/event/'+this.$route.params.id+'?token='+token)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.items = data.data;
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }

                });
        },
        computed: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    .grid-view-item{
        width: 100%;
    }
    #ecommerce-wishlist-demo {
        .item-view-primary-action-btn {
            color: #2c2c2c !important;
            background-color: #f6f6f6;
            min-width: 50%;
        }

        .item-view-secondary-action-btn {
            min-width: 50%;
        }
    }
    .news-content__inside {
        width: 75%;
        margin: auto;

        &__title {
            padding: 15px;
            padding-left: 0;
            color: #000;
            border-radius: 0;
            font-size: 30px;
        }

        &__subtitle {
            margin: 20px 0 15px 0;
        }

        &__text {
            padding: 30px;
            background: #fff;
            border-radius: 8px;
            -webkit-box-shadow: 0 2px 50px 0 rgba(0, 0, 0, .05);
            box-shadow: 0 2px 50px 0 rgba(0, 0, 0, .05);
            margin-bottom: 30px;
            overflow: hidden;
            margin-top: 0;
        }
    }
</style>
